import { InforiusApps } from '@devinforius/i-essentials';

export enum TenantApplicationIdentifier {
  IAdmin = 0,
  ICourrier = 1,
  IDelibeBackoffice = 2,
  IDelibeLight = 3,
  IValves = 4,
}

export interface TenantApp {
  identifier: TenantApplicationIdentifier;
  name: InforiusApps;
  active: boolean;
}

export class Tenant {
  private description: string = 'Tenant';
  private active: boolean = true;
  private apps: TenantApp[] = [];

  public setDescription(description: string): this {
    this.description = description;
    return this;
  }

  public setActive(active: boolean): this {
    this.active = active;
    return this;
  }

  public setApps(apps: TenantApp[]): this {
    this.apps = apps;
    return this;
  }

  public hasIDelibe(): boolean {
    const idelibeApp = this.apps.find((app) => app.identifier === TenantApplicationIdentifier.IDelibeBackoffice);

    return idelibeApp ? idelibeApp.active : false;
  }

  public hasICourrier(): boolean {
    const iCourrierApp = this.apps.find((app) => app.identifier === TenantApplicationIdentifier.ICourrier);

    return iCourrierApp ? iCourrierApp.active : false;
  }
}
